import RevisionIcon from "assets/icon/RevisionIcon"
import React from "react"

export const ReloadButton = ({onClick}) => {
    return (
        <button  
            className="bg-black rounded-md text-white px-2 py-2"
            onClick={onClick}
        >
            <RevisionIcon className="w-6 fill-white" />
        </button>
    )
}